import { Form, Formik } from 'formik';
import React, { useEffect, useState , useRef} from 'react';
import FormCol from '../../Common/common/src/formCol/FormCol';
import FormRow from '../../Common/common/src/formRow/FormRow';
import Label from '../../Common/Formik/Label';
import useObtenerCountries from '../../../Hooks/useObtenerCountries';
import InputAutocomplete from '../../Common/common/src/inputAutocomplete/InputAutoComplete';
import ContactoCountries from './ContactoCountries';

const Countries = ({ setSeleccion, setIsLastStep }) => {
    
    const [suggestionsCountries, setSuggestionsCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState();
    const [countriesConId, setCountriesConId] = useState();
    const [countries, errorCountries, isLoadingCountries, fetchCountries] =
        useObtenerCountries();
    const searchInput = useRef(null);

    useEffect(() => {
        const countriesId = setSuggestionsId(countries);
        setSuggestionsCountries(countriesId);
        setCountriesConId(countriesId);
    }, [countries]);

    useEffect(() => {
        setSeleccion(selectedCountry);
    }, [selectedCountry]);

    const handleTyping = (userInput) => {
        if (userInput.length == 0) {
            setSeleccion(null);
            setIsLastStep(false);
        }
        if (userInput.length == 3) {
            fetchCountries(userInput);
        } else {
            fetchCountriesMemory(userInput);
        }
    };

    const fetchCountriesMemory = (userInput) => {
        if (userInput?.length > 3) {
            const selectedCountries = countriesConId.filter((c) => c.name?.toLowerCase().includes(userInput.toLowerCase()));
            setSuggestionsCountries(selectedCountries);
        } else {
            if (selectedCountry) {
                setSelectedCountry(null);
            }
        }
    };

    const setSuggestionsId = (suggestions) => {
        return suggestions.map((item, Id) => ({
            ...item,
            Id,
            Barrio: item.name + ' (' + item.CodigoPostal + ')',
        }));
    };

    const handleSelectedItem = (value) => {
        setSelectedCountry(countriesConId.find((c) => c.Id == value));
    };

    return (
        <div>
            <Formik
                initialValues={{
                    nombreCountry: '',
                }}
            >
                <Form>
                    <FormRow>
                        <FormCol>
                            <Label text={'Nombre Country'} />
                            <InputAutocomplete
                                name="nombreCountry"
                                data={suggestionsCountries}
                                placeholder=""
                                value=''
                                startsAt={3}
                                isLoading={isLoadingCountries}
                                handleOnSelection={handleSelectedItem}
                                handleChange={handleTyping}
                                disabled={isLoadingCountries}
                                ref={searchInput}
                            />
                        </FormCol>
                        <ContactoCountries />
                    </FormRow>
                </Form>
            </Formik>
        </div>
    );
};

export default Countries;
